import { getLocalizedMeta } from '@/utils/common'

const Layout = () => import('@/layout/index.vue')

export default {
  name: 'RecDot',
  path: '/:language?/recdot',
  component: Layout,
  redirect: '/recdot/detail',
  children: [
    {
      name: 'recdotIndex',
      path: 'detail',
      component: () => import('@/views/recDot/index.vue'),
      meta: {
        hideTab: false,
        menu: 'RecDotDetail',
        image: '',
        ...getLocalizedMeta('detailRecDot')
      }
    }
  ]
}
